import React from "react";
import './Body10.css';
import {Link} from "react-router-dom"
import picture229 from './source/picture229.png'
import picture221 from './source/picture221.png'
import picture222 from './source/picture222.png'
import picture223 from './source/picture223.png'
import picture224 from './source/picture224.png'
import picture225 from './source/picture225.png'
import picture226 from './source/picture226.png'
import picture227 from './source/picture227.png'
import picture228 from './source/picture228.png'


function Body10() {

  return (
    <div className="body10">
      <div className="body10-box1">
        <div className="body10-box2">
          <div className="body10-box3">Moravský Písek</div>
          <div className="body10-box5"><div className="body10-box4"></div></div>
          <div className="body10-box6">
          <img className="body10-box6-picture" src={picture229} alt="picture1"/>
          <img className="body10-box6-picture" src={picture221} alt="picture1"/>
          <img className="body10-box6-picture" src={picture223} alt="picture1"/>
          <img className="body10-box6-picture" src={picture224} alt="picture1"/>
          <img className="body10-box6-picture" src={picture225} alt="picture1"/>
          <img className="body10-box6-picture" src={picture227} alt="picture1"/>
          <img className="body10-box6-picture" src={picture228} alt="picture1"/>
          <img className="body10-box6-picture2" src={picture226} alt="picture1"/>
          <img className="body10-box6-picture2" src={picture222} alt="picture1"/>
          </div>
          <div className="body10-box8"><div className="body10-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body10;
